import { Box, Button, Card, Chip, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, InputBase, InputLabel, MenuItem, OutlinedInput, Paper, Popover, Select, Stack, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { toast } from 'react-toastify';
import Iconify from 'src/components/iconify'
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { getData, postData, putData, uploadFile } from 'src/webService/webService';
import PaginationComponent from 'src/components/pagination';
import { file_URL } from '../../utils/url'

function WebsiteTeam() {

    const [open, setOpen] = useState(null);
    const UserId = sessionStorage.getItem("userId");
    const [dailyData, setDailyData] = useState("");
    const [details, setDetails] = useState(false);
    const [scroll, setScroll] = useState('paper');
    const descriptionElementRef = useRef(null);
    const [allUpdates, setAllUpdates] = useState([]);
    const [view, setView] = useState([]);
    const [selectedLead, setSelectedLead] = useState("");
    const [formOpen, setFormOpen] = useState(false);
    const [convertForm, setConvertForm] = useState(false);
    const [employeeOptions, setEmployeeOptions] = useState([]);

    const [selectedLeadId, setSelectedLeadId] = useState(null);
    const [selectedWorkUpdateId, setSelectedWorkUpdateId] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState({})
    const [fileUpload, setFileUpload] = useState(null);
    const [assignedLeads, setAssignedLeads] = useState([]);

    const sessionToken = sessionStorage.getItem("Token");
    const role = sessionStorage.getItem("role");
    const roleType = sessionStorage.getItem("roleType");
    const serviceTeamType = sessionStorage.getItem("serviceTeamType");

    const [openImage, setOpenImage] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [activeTab, setActiveTab] = useState(0)
    const [events, setEvents] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    console.log(view, "viewwww")

    const [formData, setFormData] = useState({
        completedPages: '',
        fileUpload: "",
        progressPercentage: '',
        status: "",
        contentStatus: '',
        comments: ''
    });

    const [convertData, setConvertData] = useState({
        serviceName: "WebSite Designing",
        assignedTo: [],
        employeeWork: [],
        comments: [],
    });

    const handleMultiSelectChange = (event) => {
        const {
            target: { value },
        } = event;
        setConvertData((prev) => ({
            ...prev,
            assignedTo: typeof value === 'string' ? value.split(',') : value,
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleOpenMenu = (event, task, id, workUpdateId) => {
        let lead;

        if (task && typeof task === 'object') {
            lead = task;
            setSelectedLead(lead);
        }
        else {
            lead = assignedLeads.find((data) => data._id === id);
            setSelectedLead(lead);
        }

        if (event?.currentTarget) {
            setOpen(event.currentTarget);
            setSelectedLeadId(id);
            setSelectedWorkUpdateId(workUpdateId);
            setView(lead || task);
        }
    };

    const handleCloseMenu = () => {
        setOpen(null);
    };

    const handleOpenDialog = async () => {
        await getAllUpdatesAdmin();
        setDetails(true);
        handleCloseMenu();
    };

    const handleCloseDialog = () => {
        setDetails(false);
    };

    const handleOpen = async () => {
        setFormOpen(true);
        handleCloseMenu();
    }

    const handleClose = () => {
        setFormOpen(false)
    }

    const handleFormOpen = async (leadId) => {
        await getAllUsers();
        setSelectedLeadId(leadId)
        setConvertForm(true)
        setOpen(false)
        // handleFormClose()
    }

    const handleFormClose = () => {
        setConvertForm(false)
    }

    const getAllUsers = async () => {
        try {
            const params = { page: 1, limit: 1000 }
            const response = await getData("users/users", params);
            console.log("Response:", response);

            const filteredUsers = response.data.results.filter(user =>
                user.serviceTeamType && user.serviceTeamType.includes("WebSite Designing")
            );

            const formattedOptions = filteredUsers.map(user => ({
                id: user._id,
                name: user.name
            }));

            setEmployeeOptions(formattedOptions);

        } catch (error) {
            console.error("Error fetching users:", error);
            toast.error(`Failed to load users ${error ? error : ''}`);
        }
    };

    const convertLeads = async () => {
        debugger;
        try {
            const params = {
                serviceName: ["WebSite Designing"],
                assignedTo: convertData.assignedTo,
                employeeWork: convertData.employeeWork,
                servieStatus: "In Progress",
                noOfPosters: convertData.noOfPosters,
                comments: convertData.comments,
                deadline: convertData.deadline,
                status: convertData.status,
            };

            const response = await putData(`leads/lead/${selectedLeadId}/status`, params, sessionToken);

            if (response.status === 200) {
                setConvertForm(false);
                toast.success("Lead Assigned successfully!");
            } else {
                toast.error("Failed to assign lead.", response?.message);
            }
        } catch (error) {
            console.error("Error while assigning lead:", error);
            toast.error(`Something went wrong while assigning the lead. ${error ? error : ''}`);
        }
    };

    const fetchAssignedLeads = async () => {
        debugger
        try {
            let response;
            let websiteDesigningLeads = [];

            if (role === "Admin" || roleType === "Team Leader") {
                const params = { page: currentPage, limit: limit, serviceName: "WebSite Designing" }
                response = await getData("leads/services", params, sessionToken);
                console.log("Admin Response", response);
                websiteDesigningLeads = response.data.results[0].paginatedResults;

                const totalRecords = response?.data.results[0]?.totalCount;
                setTotalPages(response?.data.results[0]?.totalPages);
                setTotalCount(totalRecords);
            } else if (roleType === "Employee") {
                const params = {
                    page: currentPage,
                    limit: limit
                };

                const endpoint = `leads/leads/${UserId}`;

                response = await getData(endpoint, params, sessionToken);
                console.log(`${roleType} Response`, response);

                if (roleType === "Employee" && response?.data) {
                    debugger
                    const leadsData = Array.isArray(response.data)
                        ? response.data[0]?.paginatedResults
                        : response.data[0]?.paginatedResults || [];

                    websiteDesigningLeads = leadsData;
                    const totalRecords = response.data[0].totalCount.totalItems;
                    setTotalPages(response.data[0].totalPages === null ? 0 : response.data[0].totalPages);
                    setTotalCount(totalRecords);

                }
            }


            console.log("Website Leads", websiteDesigningLeads);
            setAssignedLeads(websiteDesigningLeads);

            const latestDeadlines = {};
            websiteDesigningLeads.forEach(lead => {
                const leadId = lead._id;
                const deadline = lead.websiteDesigningHistory?.deadline;
                if (deadline && (!latestDeadlines[leadId] ||
                    new Date(deadline) > new Date(latestDeadlines[leadId].deadline))) {
                    latestDeadlines[leadId] = lead;
                }
            });

            const latestDeadlinesArray = Object.values(latestDeadlines);

            const deadlineEvents = latestDeadlinesArray.map(lead => ({
                id: lead._id + '-deadline',
                title: `Deadline: ${lead.websiteDesigningHistory?.contentType || 'Content'}`,
                start: lead.websiteDesigningHistory?.deadline,
                allDay: true,
                extendedProps: {
                    type: 'deadline',
                    leadName: lead.name,
                    contentType: lead.websiteDesigningHistory?.contentType,
                    progress: lead.websiteDesigningHistory?.progressPercentage
                        ? `${Math.round(lead.websiteDesigningHistory.progressPercentage)}%`
                        : '0%'
                },
                backgroundColor: '#FF8A80',
                borderColor: '#FF8A80',
                textColor: '#000'
            }));

            setEvents(prevEvents => [...prevEvents, ...deadlineEvents]);

        } catch (err) {
            console.error("Error while fetching Website Designing Team:", err);
            toast.error(`Failed to load Website Designing Team. ${err ? err : ''}`);
        }
    };

    const getDailyUpdates = async () => {
        debugger
        try {
            const response = await getData(`dailyworkupdates/user/${UserId}`, {}, sessionToken);
            console.log("Response Daily Updates:", response)
            const results = response?.data;
            console.log("Results:", results)
            setDailyData(results);

        } catch (err) {
            console.error("Error while fetching Website Designing Team:", err);
            toast.error(`Failed to load Website Designing Team. ${err ? err : ''}`);
        }

    }

    const getAllUpdatesAdmin = async () => {

        const params = {
            page: 1,
            limit: 1000
        }

        try {
            const response = await getData("dailyworkupdates/updates", params, sessionToken);
            console.log("Response Dailyyy Updates:", response)

            const filteredData = response?.data[0]?.paginatedResults?.filter(lead => lead.serviceName === "WebSite Designing");

            console.log("Filtered Data:", filteredData);
            setAllUpdates(filteredData);

        } catch (err) {
            console.error("Error while fetching Website Designing Team:", err);
            toast.error(`Failed to load Website Designing Team. ${err ? err : ''}`);
        }

    }

    const handleFileChange = (event, leadId) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFiles(prev => ({ ...prev, [leadId]: file }));
            handleFileUpload(file, leadId);
        }
    };

    const handleFileUpload = async (fileupload, leadId) => {
        console.log("Fileupload:", fileupload);
        console.log("Is File:", fileupload instanceof File);

        const formDataToSend = new FormData();
        formDataToSend.append("file", fileupload);

        try {
            const response = await uploadFile(`files/upload/${selectedLeadId}`, formDataToSend);
            if (response?.status === 200) {
                toast.success("File uploaded successfully!");
                setFileUpload(response?.data);
                setFormData(prevState => ({
                    ...prevState,
                    fileupload: response?.data,
                }));
            } else {
                toast.error("File upload failed!", response?.message);
            }
        } catch (error) {
            console.error("File upload error:", error);
            toast.error(`Error uploading file. ${error ? error : ''}`);
        }
    };

    const postDailyWorkUpdate = async () => {
        debugger;
        try {
            const checkResponse = await getData(`dailyworkupdates/${selectedLeadId}`, {}, sessionToken);
            const existingUpdates = checkResponse?.data?.flatMap(update => update?.websiteDesigningHistory?.map(history => history?.dailyUpdateId)) || [];

            const websiteDesigningHistory = selectedLead?.websiteDesigningHistory?.[0] ||
                selectedLead?.websiteDesigningHistory ||
                {};
            const previousCompleted = websiteDesigningHistory.completedPages || 0;
            const newCompleted = parseInt(formData.completedPages, 10) || 0;
            const totalCompleted = previousCompleted + newCompleted;

            const websiteType = selectedLead?.websiteDesigningHistory?.[0]?.websiteType ||
                selectedLead?.websiteDesigningHistory?.websiteType ||
                '';

            const totalPages = selectedLead?.websiteDesigningHistory?.[0]?.totalPages ||
                selectedLead?.websiteDesigningHistory?.totalPages ||
                '';

            const amount = selectedLead?.websiteDesigningHistory?.[0]?.amount ||
                selectedLead?.websiteDesigningHistory?.amount ||
                '';
            const assignedTo = selectedLead?.websiteDesigningHistory?.[0]?.assignedTo ||
                selectedLead?.websiteDesigningHistory?.assignedTo ||
                '';

            const payLoad = {
                amount,
                assignedTo,
                completedPages: totalCompleted,
                fileUpload: fileUpload,
                progressPercentage: formData.progressPercentage,
                status: formData.status,
                contentStatus: formData.contentStatus,
                comments: formData.comments,
                websiteType: websiteType,
                totalPages: totalPages,
                serviceName: "WebSite Designing",
                leadId: selectedLeadId,
                userId: UserId
            };

            let response;

            if (existingUpdates.length === 0) {
                response = await postData('dailyworkupdates', payLoad, sessionToken);
            } else {
                // PUT update existing record
                const updateId = existingUpdates[existingUpdates.length - 1];
                response = await putData(`dailyworkupdates/dailyworkupdates/${updateId}`, payLoad, sessionToken);
            }

            if (response?.status === 200) {
                toast.success("Daily Work Updated Successfully!");
                handleClose();
                getDailyUpdates();
            } else {
                throw new Error(response?.message || "Failed to update Daily Work.");
            }

        } catch (error) {
            console.error("Error:", error);
            toast.error(`${error ? error : ''}`);
        }
    }

    const handleLimitChange = (event) => {
        setCurrentPage(1);
        if (currentPage === 1) {
            setLimit(event.target.value)
            fetchAssignedLeads(1, event.target.value)
        }
        else {
            setCurrentPage(1);
            setLimit(event.target.value);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
            fetchAssignedLeads(currentPage - 1, limit);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
            fetchAssignedLeads(currentPage + 1, limit);
        }
    };

    const calculateIndex = (index) => {
        return (currentPage - 1) * limit + index + 1;
    };

    useEffect(() => {
        getAllUsers();
        getAllUpdatesAdmin();
        fetchAssignedLeads(currentPage, limit);
        if (roleType === "Employee") {
            getDailyUpdates();
        }
    }, [role, roleType, serviceTeamType, currentPage, limit]);

    return (
        <>
            <Helmet>
                <title>Service | Website Team</title>
            </Helmet>
            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Website Team
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                backgroundColor: "white",
                                borderRadius: "15px",
                                padding: "4px 12px",
                                boxShadow: 1,
                                marginRight: "20px"
                            }}
                        >
                            <Iconify icon="eva:search-fill" />
                            <InputBase
                                placeholder="Search"
                                sx={{ marginLeft: "8px" }}
                            />
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 2 }}>
                            {
                                (role === "Admin" || roleType === "Team Leader") && (
                                    <Tabs
                                        value={activeTab}
                                        onChange={(e, newValue) => setActiveTab(newValue)}
                                        aria-label="content creation views"
                                    >
                                        <Tab label="Calendar View" />
                                        <Tab label="Table View" />
                                    </Tabs>
                                )
                            }
                        </Box>
                    </Box>
                </Stack>
                <Card sx={{ padding: 1, boxShadow: 3, backgroundColor: "#fff" }}>
                    {(role === "Admin" || roleType === "Team Leader") && activeTab === 0 && (
                        <Box sx={{ height: 500 }}>
                            <FullCalendar
                                plugins={[dayGridPlugin, interactionPlugin]}
                                initialView="dayGridMonth"
                                headerToolbar={{
                                    start: "",
                                    center: 'prev title next',
                                    end: ""
                                }}
                                events={events}
                                eventContent={renderEventContent}
                                height="100%"
                            />
                        </Box>
                    )}
                    {
                        ((role === "Admin" || roleType === "Team Leader") && activeTab === 1) || roleType === "Employee" ? (
                            <>
                                <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
                                    {
                                        role === "Admin" || roleType === "Team Leader" ? (
                                            <Table>
                                                <TableHead>
                                                    <TableCell>S.No</TableCell>
                                                    {/* <TableCell>Assigned User</TableCell> */}
                                                    <TableCell>Lead Name</TableCell>
                                                    <TableCell>Email</TableCell>
                                                    <TableCell>Phone</TableCell>
                                                    <TableCell>Project</TableCell>
                                                    {/* <TableCell>Assigned Tasks</TableCell> */}
                                                    <TableCell>Completed Tasks</TableCell>
                                                    <TableCell>File</TableCell>
                                                    <TableCell>Status</TableCell>
                                                    <TableCell></TableCell>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        assignedLeads.length === 0 ? (
                                                            <TableRow>
                                                                <TableCell colSpan={7} align="center">
                                                                    No data found
                                                                </TableCell>
                                                            </TableRow>
                                                        ) : (
                                                            assignedLeads?.map((task, id) => {
                                                                return (
                                                                    <TableRow key={task?.id}>
                                                                        <TableCell>{calculateIndex(id)}</TableCell>
                                                                        {/* <TableCell>{task?.assignedTo?.name || task.name}</TableCell> */}
                                                                        <TableCell>{task?.name}</TableCell>
                                                                        <TableCell>{task?.email}</TableCell>
                                                                        <TableCell>{task?.phone}</TableCell>
                                                                        <TableCell>{task?.websiteDesigningHistory?.websiteType}</TableCell>
                                                                        {/* <TableCell>{task?.websiteDesigningHistory?.assignedPages}</TableCell> */}
                                                                        <TableCell>{task?.websiteDesigningHistory?.completedPages} / {task?.websiteDesigningHistory?.totalPages}</TableCell>
                                                                        <TableCell>
                                                                            {task?.websiteDesigningHistory?.fileUpload?.path ?
                                                                                <img
                                                                                    src={task?.websiteDesigningHistory?.fileUpload?.path
                                                                                        ? `${file_URL + encodeURI(task?.websiteDesigningHistory?.fileUpload?.path.replace("public/", ""))}`
                                                                                        : "#"}
                                                                                    alt='Image.png'
                                                                                    style={{ maxWidth: "50px", cursor: "pointer" }}
                                                                                    onClick={() => {
                                                                                        const fullImage = task?.websiteDesigningHistory?.fileUpload?.path
                                                                                            ? `${file_URL + encodeURI(task?.websiteDesigningHistory?.fileUpload?.path.replace("public/", ""))}`
                                                                                            : "#";
                                                                                        setSelectedImage(fullImage);
                                                                                        setOpenImage(true);
                                                                                    }}
                                                                                />
                                                                                : "-"}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            <Box position="relative" display="inline-flex">
                                                                                <CircularProgress
                                                                                    variant="determinate"
                                                                                    value={task?.websiteDesigningHistory?.progressPercentage}
                                                                                />
                                                                                <Box
                                                                                    top={0}
                                                                                    left={0}
                                                                                    bottom={0}
                                                                                    right={0}
                                                                                    position="absolute"
                                                                                    display="flex"
                                                                                    alignItems="center"
                                                                                    justifyContent="center"
                                                                                >
                                                                                    <Typography variant="caption" component="div" color="text.secondary">
                                                                                        {`${Math.round(task?.websiteDesigningHistory?.progressPercentage)}%`}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            <Iconify
                                                                                icon="material-symbols-light:more-vert"
                                                                                sx={{ margin: "auto" }}
                                                                                onClick={(event) => handleOpenMenu(event, task, task._id, task.websiteDesigningHistory?.dailyUpdateId)}
                                                                            />
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            })
                                                        )
                                                    }
                                                </TableBody>
                                            </Table>
                                        ) : roleType === "Employee" ? (
                                            <Table>
                                                <TableHead>
                                                    <TableCell>S.No</TableCell>
                                                    <TableCell>Name</TableCell>
                                                    <TableCell>Contact</TableCell>
                                                    <TableCell>Website Type</TableCell>
                                                    <TableCell>Assigned Tasks</TableCell>
                                                    <TableCell>Assigned Pages</TableCell>
                                                    <TableCell>Deadline</TableCell>
                                                    <TableCell>Completed Pages</TableCell>
                                                    <TableCell>File</TableCell>
                                                    {/* <TableCell>Work Details</TableCell> */}
                                                    <TableCell>Progress</TableCell>
                                                    <TableCell></TableCell>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        assignedLeads?.length === 0 ? (
                                                            <TableRow>
                                                                <TableCell colSpan={7} align="center">
                                                                    No data found
                                                                </TableCell>
                                                            </TableRow>
                                                        ) : (
                                                            assignedLeads?.map((work, id) => {
                                                                return (
                                                                    <TableRow key={work?.id}>
                                                                        <TableCell>{calculateIndex(id)}</TableCell>
                                                                        <TableCell>{work?.name}</TableCell>
                                                                        <TableCell>{work?.phone}</TableCell>
                                                                        <TableCell>{work?.websiteDesigningHistory[0]?.websiteType}</TableCell>
                                                                        <TableCell>{work?.currentWork?.noOfPosters}</TableCell>
                                                                        <TableCell>{work?.currentWork?.comments}</TableCell>
                                                                        <TableCell>{work?.currentWork !== null ? new Date(work?.currentWork?.deadline).toLocaleDateString() : "-"}</TableCell>
                                                                        <TableCell>{work?.websiteDesigningHistory[0]?.completedPages} / {work?.websiteDesigningHistory[0]?.totalPages}</TableCell>
                                                                        <TableCell>
                                                                            <img
                                                                                src={work?.websiteDesigningHistory[0]?.fileUpload?.path
                                                                                    ? `${file_URL + encodeURI(work?.websiteDesigningHistory[0]?.fileUpload?.path.replace("public/", ""))}`
                                                                                    : "#"}
                                                                                alt='Image.png'
                                                                                style={{ maxWidth: "50px", cursor: "pointer" }}
                                                                                onClick={() => {
                                                                                    const fullImage = work?.websiteDesigningHistory[0]?.fileUpload?.path
                                                                                        ? `${file_URL + encodeURI(work?.websiteDesigningHistory[0]?.fileUpload?.path.replace("public/", ""))}`
                                                                                        : "#";
                                                                                    setSelectedImage(fullImage);
                                                                                    setOpenImage(true);
                                                                                }}
                                                                            />
                                                                        </TableCell>
                                                                        {/* <TableCell>{work?.websiteDesigningHistory[0]?.workDetails}</TableCell> */}
                                                                        <TableCell align="center">
                                                                            <Box position="relative" display="inline-flex">
                                                                                <CircularProgress
                                                                                    variant="determinate"
                                                                                    value={work?.websiteDesigningHistory[0]?.progressPercentage}
                                                                                />
                                                                                <Box
                                                                                    top={0}
                                                                                    left={0}
                                                                                    bottom={0}
                                                                                    right={0}
                                                                                    position="absolute"
                                                                                    display="flex"
                                                                                    alignItems="center"
                                                                                    justifyContent="center"
                                                                                >
                                                                                    <Typography variant="caption" component="div" color="text.secondary">
                                                                                        {typeof work?.websiteDesigningHistory[0]?.progressPercentage === 'number'
                                                                                            ? `${Math.round(work.websiteDesigningHistory[0].progressPercentage)}%`
                                                                                            : '0%'}
                                                                                    </Typography>

                                                                                </Box>
                                                                            </Box>
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            <Iconify
                                                                                icon="material-symbols-light:more-vert"
                                                                                sx={{ margin: "auto" }}
                                                                                onClick={(event) => {
                                                                                    console.log('Work object:', work);
                                                                                    handleOpenMenu(event, work, work._id, work?.websiteDesigningHistory[0]?.dailyUpdateId);
                                                                                }}
                                                                            />
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            })
                                                        )
                                                    }
                                                </TableBody>
                                            </Table>
                                        ) : null
                                    }
                                </TableContainer>
                                <PaginationComponent
                                    name={"Leads"}
                                    totalcount={totalCount}
                                    limit={limit}
                                    handleLimitChange={handleLimitChange}
                                    handlePrevPage={handlePrevPage}
                                    handleNextPage={handleNextPage}
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                />
                            </>
                        ) : null
                    }
                </Card>

                {/* Edit Menu  */}
                <Popover
                    open={Boolean(open)}
                    anchorEl={open}
                    onClose={handleCloseMenu}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                        sx: {
                            p: 1,
                            width: 140,
                            '& .MuiMenuItem-root': {
                                px: 1,
                                typography: 'body2',
                                borderRadius: 0.75,
                            },
                        },
                    }}
                >
                    {
                        role === "Admin" ? (
                            <MenuItem onClick={handleOpenDialog}>
                                <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                                View
                            </MenuItem>
                        ) : roleType === "Team Leader" ? (
                            <>
                                <MenuItem onClick={handleOpenDialog}>
                                    <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                                    View
                                </MenuItem>
                                <MenuItem onClick={() => handleFormOpen(selectedLeadId)}>
                                    <Iconify icon="material-symbols:sync-alt" sx={{ mr: 2 }} />
                                    Convert
                                </MenuItem>
                                {/* <MenuItem onClick={handleOpen}>
                                    <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
                                    Work Update
                                </MenuItem> */}
                            </>
                        ) : (
                            <>
                                <MenuItem onClick={handleOpen}>
                                    <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
                                    Work Update
                                </MenuItem>

                                <MenuItem sx={{ color: 'error.main' }}>
                                    <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                                    Delete
                                </MenuItem>
                            </>
                        )
                    }
                </Popover>

                <Dialog
                    open={details}
                    onClose={handleCloseDialog}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <DialogTitle id="scroll-dialog-title">
                        <Typography variant='h5' component="div" sx={{ fontWeight: "bold" }}>
                            Daily Work Updates
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                            component="div"
                        >
                            {!view || Object.keys(view).length === 0 ? (
                                <Box sx={{ p: 3, textAlign: 'center' }}>
                                    <Typography variant='h6' color="text.secondary">No data found</Typography>
                                </Box>
                            ) : (
                                <Box sx={{ p: 1 }}>
                                    <Paper
                                        elevation={3} sx={{
                                            p: 2,
                                            backgroundColor: '#ffffff',
                                            borderRadius: 2,
                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                            borderLeft: '5px solid #1976d2'
                                        }}
                                    >
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Project Details
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Name: {view?.name}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Requirements: {view?.websiteDesigningHistory?.requirements}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Deadline: {new Date(view?.websiteDesigningHistory?.deadline).toLocaleDateString()}
                                                </Typography>
                                            </Grid>
                                            {role === "Admin" && (
                                                <Grid item xs={12} sm={6} id="paddingTop">
                                                    <Typography variant="body1">
                                                        Paid Amount: {view?.websiteDesigningHistory?.amount}
                                                    </Typography>
                                                </Grid>
                                            )}
                                            {role === "Admin" && (
                                                <Grid item xs={12} sm={6} id="paddingTop">
                                                    <Typography variant="body1">
                                                        Payment Status: <Typography component="span" sx={{
                                                            fontWeight: 'bold',
                                                            color: view?.websiteDesigningHistory?.paymentStatus === 'Completed' ? 'success.main' :
                                                                view?.websiteDesigningHistory?.paymentStatus === 'In Progress' ? 'warning.main' : 'error.main'
                                                        }}>
                                                            {view?.websiteDesigningHistory?.paymentStatus}
                                                        </Typography>
                                                    </Typography>
                                                </Grid>
                                            )}
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Website Type: {view?.websiteDesigningHistory?.websiteType}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Comments: {view?.websiteDesigningHistory?.comments}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Task Progress
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Completed Pages: {view?.websiteDesigningHistory?.completedPages}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Total Pages: {view?.websiteDesigningHistory?.totalPages}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Progress: <Typography component="span" sx={{ fontWeight: 'bold', color: '#007bff' }}>
                                                        {view?.websiteDesigningHistory?.progressPercentage}%
                                                    </Typography>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Status: <Typography component="span" sx={{
                                                        fontWeight: 'bold',
                                                        color: view?.websiteDesigningHistory?.status === 'Completed' ? 'success.main' :
                                                            view?.websiteDesigningHistory?.status === 'In Progress' ? 'warning.main' : 'error.main'
                                                    }}>
                                                        {view?.websiteDesigningHistory?.status}
                                                    </Typography>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Domain Details
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Cost: {view?.websiteDesigningHistory?.domainCost ? view?.websiteDesigningHistory?.domainCost : "-"}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Provider: {view?.websiteDesigningHistory?.domainProvider ? view?.websiteDesigningHistory?.domainProvider : "-"}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Renewal Date: {view?.websiteDesigningHistory?.domainRenewalDate ? new Date(view?.websiteDesigningHistory?.domainRenewalDate).toLocaleDateString() : "-"}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Hosting Details
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Cost: {view?.websiteDesigningHistory?.hostingCost ? view?.websiteDesigningHistory?.hostingCost : "-"}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Provider: {view?.websiteDesigningHistory?.hostingProvider ? view?.websiteDesigningHistory?.hostingProvider : "-"}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Renewal Date: {view?.websiteDesigningHistory?.hostingRenewalDate ? new Date(view?.websiteDesigningHistory?.hostingRenewalDate).toLocaleDateString() : "-"}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Timestamps
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Created: {new Date(view?.createdAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Updated: {new Date(view?.updatedAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Box>
                            )}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog}>Close</Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={formOpen}
                    onClose={handleClose}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <DialogTitle id="scroll-dialog-title">Daily Work Update!</DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                        >
                            <TextField
                                margin="dense"
                                label="Completed Pages"
                                name="completedPages"
                                value={formData.completedPages}
                                onChange={handleChange}
                                type="number"
                                fullWidth
                            />

                            <TextField
                                margin="dense"
                                label="Status"
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                                select
                                fullWidth
                            >
                                <MenuItem value="Pending">Pending</MenuItem>
                                <MenuItem value="In Progress">In Progress</MenuItem>
                                <MenuItem value="Completed">Completed</MenuItem>
                            </TextField>

                            <TextField
                                margin="dense"
                                label="Comments"
                                name="comments"
                                value={formData.comments}
                                onChange={handleChange}
                                multiline
                                fullWidth
                            />
                            <TextField
                                margin='dense'
                                type='file'
                                hidden
                                label="Upload File"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => handleFileChange(e)}
                            >
                            </TextField>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button onClick={postDailyWorkUpdate}>Submit</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={openImage} onClose={() => setOpenImage(false)} maxWidth="md">
                    <Iconify
                        icon="material-symbols:close"
                        onClick={() => setOpenImage(false)}
                        style={{
                            position: 'absolute',
                            top: 10,
                            right: 10,
                            fontSize: 24,
                            cursor: 'pointer',
                            zIndex: 1
                        }}
                    />
                    <DialogContent>
                        <img src={selectedImage} alt="Full View" style={{ width: "100%", height: "auto" }} />
                    </DialogContent>
                </Dialog>

                {/* Assign leads */}
                <Dialog open={convertForm}>
                    <DialogTitle>Convert Leads</DialogTitle>
                    <DialogContent>
                        <FormControl fullWidth margin="dense">
                            <InputLabel id="assign-to-label">Assign To</InputLabel>
                            <Select
                                labelId="assign-to-label"
                                multiple
                                value={convertData.assignedTo}
                                onChange={handleMultiSelectChange}
                                InputLabelProps={{ shrink: true }}
                                label="Assign To"
                                input={<OutlinedInput label="Assign To" />}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value) => {
                                            const employee = employeeOptions.find(emp => emp.id === value);
                                            return employee ? (
                                                <Chip key={value} label={employee.name} />
                                            ) : null;
                                        })}
                                    </Box>
                                )}
                                fullWidth
                            >
                                {employeeOptions.map((emp) => (
                                    <MenuItem key={emp.id} value={emp.id}>
                                        {emp.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Box sx={{ mt: 2 }}>
                            {convertData.assignedTo.map((empId) => {
                                const employee = employeeOptions.find(emp => emp.id === empId);
                                return (
                                    <>
                                        <Box key={empId} sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 2 }}>
                                            <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                                                <div className='col' style={{ marginTop: "5px" }}>
                                                    <Typography>{employee?.name}</Typography>
                                                </div>
                                            </div>
                                        </Box>
                                        <Box key={empId} sx={{ alignItems: 'center', mb: 1, gap: 2 }}>
                                            <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginBottom: "10px" }}>
                                                <TextField
                                                    label="Comments"
                                                    value={convertData.employeeWork?.[empId]?.comments || ""}
                                                    onChange={(e) => {
                                                        const work = e.target.value;
                                                        setConvertData(prev => ({
                                                            ...prev,
                                                            employeeWork: {
                                                                ...prev.employeeWork,
                                                                [empId]: {
                                                                    ...prev.employeeWork?.[empId],
                                                                    comments: work
                                                                }
                                                            }
                                                        }));
                                                    }}
                                                    size="small"
                                                    fullWidth
                                                />
                                                <TextField
                                                    label="No of Pages"
                                                    value={convertData.employeeWork?.[empId]?.noOfPosters || ""}
                                                    onChange={(e) => {
                                                        const work = e.target.value;
                                                        setConvertData(prev => ({
                                                            ...prev,
                                                            employeeWork: {
                                                                ...prev.employeeWork,
                                                                [empId]: {
                                                                    ...prev.employeeWork?.[empId],
                                                                    noOfPosters: work
                                                                }
                                                            }
                                                        }));
                                                    }}
                                                    size="small"
                                                    fullWidth
                                                />
                                                <TextField
                                                    label="Deadline"
                                                    value={convertData.employeeWork?.[empId]?.deadline || ""}
                                                    onChange={(e) => {
                                                        const work = e.target.value;
                                                        setConvertData(prev => ({
                                                            ...prev,
                                                            employeeWork: {
                                                                ...prev.employeeWork,
                                                                [empId]: {
                                                                    ...prev.employeeWork?.[empId],
                                                                    deadline: work
                                                                }
                                                            }
                                                        }));
                                                    }}
                                                    type='date'
                                                    size="small"
                                                    fullWidth
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </div>
                                        </Box>
                                    </>
                                );
                            })}
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleFormClose} color="secondary">Cancel</Button>
                        <Button onClick={convertLeads} color="primary">Submit</Button>
                    </DialogActions>
                </Dialog>
            </Container>
        </>
    )
}

function renderEventContent(eventInfo) {
    const isDeadline = eventInfo.event.extendedProps.type === 'deadline';
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: isDeadline ? '#FFEBEE' : '#F5F5F5',
            borderRadius: '8px',
            padding: '6px',
            marginTop: '5px',
            boxShadow: 2,
            fontSize: '12px',
            color: 'black',
            maxWidth: "125px",
            borderLeft: `4px solid ${eventInfo.event.backgroundColor || '#90CAF9'}`
        }}>
            <Box sx={{
                borderLeft: `4px solid ${eventInfo.event.extendedProps.color || '#90CAF9'}`,
                paddingLeft: '6px'
            }}>
                {isDeadline ? (
                    <>
                        <strong>⏰</strong>
                        <div>Lead: {eventInfo.event.extendedProps.leadName}</div>
                        <div>Progress: {eventInfo.event.extendedProps.progress}</div>
                    </>
                ) : (
                    <>
                        <strong>📝 {eventInfo.event.title}</strong>
                        <div>Lead: {eventInfo.event.extendedProps.leadName}</div>
                        <div>Req: {eventInfo.event.extendedProps.requirement}</div>
                        <div>Status: {eventInfo.event.extendedProps.status}</div>
                        <div>Progress: {eventInfo.event.extendedProps.progress}</div>
                    </>
                )}
            </Box>
        </Box>
    );
}

export default WebsiteTeam
